
SUGApp.service('modalMessageService', ['SUGUtilities','$filter','userService','$location','$window', function(util,$filter,userService,$location,$window){
	var today = new Date();
	var startdate = new Date(today.getFullYear(),today.getMonth(),today.getDate()-30);
	var enddate = new Date(today.getFullYear(),today.getMonth(),today.getDate()+30);

	var service = {
		searchSettings : {
			startDate: startdate,
			endDate: enddate,
			formattedStartDate: $filter('date')(startdate, 'yyyy-MM-dd'),
			formattedEndDate: $filter('date')(enddate, 'yyyy-MM-dd'),

			filterBy: '',
			sortBy: "startdate",
			sortReverse: false,
			activeTrue: true,
			activeFalse: true,
			showArchived: false,
			validationFail: '',
			validationError: ''
		},
		pageSettings : {
			currentPage: 1,
			maxSize: 15,
			totalItems: 0,
			numPerPage: 20
		}
	};

	service.pageTitle = function() {
		return 'Modal Message Management';
	};

	service.userPermissions = function() {
		var permissions = userService.permissions;
		var permissionsArray = permissions.split(",");
		var userPermissions = {};
		for (var i in permissionsArray) {
			userPermissions[permissionsArray[i].split(' ').join('_')] = true;
		}

		return util.lowerCaseKeys(userPermissions);
	};

	service.today = function() {
		var dt =  new Date();
		return dt;
	};

	service.membertype = function(){
		return [
				{ value: 'all', label: 'All Users' },
				{ value: 'paid', label: 'Paid Users' },
				{ value: 'nonpaid', label: 'Non-Paid Users' },
				{ value: 'payments', label: 'Payments Users' },
				{ value: 'nonpayments', label: 'Non-Payments Users' },
				{ value: 'trial', label: 'Trial Users' }
/* Removed for now because marketing doesn't need them.
				,
				{ value: 'basic', label: 'Basic Users' },
 				{ value: 'trial', label: 'Trial Users' },
				{ value: 'firsttime', label: 'First Time Users' },
 				{ value: 'silver', label: 'Silver Users' },
 				{ value: 'gold', label: 'Gold Users' },
 				{ value: 'platinum', label: 'Platinum Users' },
				{ value: 'enterprise', label: 'Enterprise Users' }
*/
			];
	};
	service.priority = function(){
		return [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ];
	};

	service.mediatype = function(){
		return [
				{ value: 'image', label: 'Image' },
				{ value: 'video', label: 'Video (Vimeo)' },
				{ value: 'text', label: 'Text' }
			];
	};

	service.linktype = function(){
		return [
			{ id: 1, label: 'Basic' }
			//,{ id: 2, label: 'Click Meter' }
		];
	};

	service.messageDefaults = function(dt){
		var messageDefault  = {};
		messageDefault.id = 0;
		messageDefault.randomtotal = 0;
		messageDefault.startdate = dt;
		messageDefault.starttime = "00:00";
		messageDefault.endtime = "23:59";
		messageDefault.messagepriority  = 1;
		messageDefault.displaypage = [1];   // **** TO DO ?: May need to update this to populate dynamically
		messageDefault.mediatype = 'image';
		messageDefault.mediafile = '';
		messageDefault.mediaalttag = '';
		messageDefault.bodytext = '';
		messageDefault.buttontext = 'Learn More';
		messageDefault.showto = 'all';
		messageDefault.videolink = '';
		messageDefault.messageratio1 = 1;
		messageDefault.messageratio2 = 1;
		messageDefault.displayonce = 0;
		messageDefault.displaydelay = 1;
		messageDefault.active = 0;
		messageDefault.messagebody = '';
		messageDefault.mediasize = 610;
		messageDefault.modalmaxsize = messageDefault.mediasize + 80;
		messageDefault.linktype = 2;
		messageDefault.openinnewwindow = true;

		return messageDefault;
	};


	//Goto location subtroutine
	service.goToLocation = function(event) {
		//scroll to the top of the page
		scrollTo(0, 0);
		$location.path(event);
	};

	service.clickMeterLinksHardcoded = function() {
		return {
			"MESSAGE": "",
			"CODE": "",
			"SUCCESS": true,
			"DATA": {
				"success": true,
				"datapoints": []
			}
		};
	};
	service.determineModalMessageToDisplay = function(data){
		return util.APISyncCall( "post", "", data, "c.determineModalMessageToDisplay", 15000 );
	};

	service.trackModalImpression = function(data){
		return util.APISyncCall( "post", "", data, "c.trackModalImpression", 15000 );
	};

	service.downloadModalStats = function(data){
		return util.APISyncCall( "post", "", data, "a.downloadModalStats", 300000 );
	};

	service.getMessageList = function(data){
		return util.APISyncCall( "post", "", data, "a.getModalMessageList", 15000 );
	};

	service.getModalMessageByID = function(data){
		return util.APISyncCall( "post", "", data, "a.getModalMessageByID", 15000 );
	};

	service.saveModalMessage = function(data){
		return util.APISyncCall( "post", "", data, "a.saveModalMessage", 15000 );
	};

	service.deleteModalMessage = function(data){
		return util.APISyncCall( "post", "", data, "a.deleteModalMessage", 15000 );
	};

	service.activateModalMessage = function(data){
		return util.APISyncCall( "post", "", data, "a.activateModalMessage", 15000 );
	};

	service.archiveModalMessage = function(data){
		return util.APISyncCall( "post", "", data, "a.archiveModalMessage", 15000 );
	};

	service.unArchiveModalMessage = function(data){
		return util.APISyncCall( "post", "", data, "a.unArchiveModalMessage", 15000 );
	};

	service.deactivateModalMessage = function(data){
		return util.APISyncCall( "post", "", data, "a.deactivateModalMessage", 15000 );
	};

	service.uploadImage = function(data){
		return util.APISyncCall( "post", "", data, "a.uploadImage", 15000 );
	};

	service.getDisplayPages = function(data){
		return util.APISyncCall( "post", "", data, "a.getDisplayPages", 15000 );
	};

	 service.getModalMessageTypes = function(data){
				return util.APISyncCall( "post", "", data, "a.getModalMessageTypes", 15000 );
	 };

	 service.getClickMeterDataPoints = function(data){
				return util.APISyncCall( "post", "", data, "a.allClickMeterDataPoints", 15000 );
	 };

	 // use this for displaying an error modal
	 service.errorHandler = function (errorObj) {
		 var errMessage = util.resultErrorHandler(errorObj);
		 if (errMessage.indexOf('Make sure you are logged in and have an active session.') >= 0) {
			 $window.location.reload();
			 return;
		 }
		 // no longer logged in
		 if (errorObj.CODE && errorObj.CODE === 1002) {
			 $window.location.reload();
			 return;
		 } else {
			 util.showMagnificAlert(errMessage, 'error', '', 'Sorry!');
		 }
	 };

	return service;


}]);
